module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aVuZaJ/tc-custom/9781504076944.jpg?1690364120974",
      "alt": "This image is the cover for the book Legacy of Eve"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legacy of Eve\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“Absolutely brilliant . . . had me hooked . . . heart-wrenching.” —Goodreads reviewer, five stars"), _c('br'), _c('br'), _c('b', [_vm._v("Can she discover the truth about her long-lost mother before becoming a mother herself? A tale of fear and family secrets by the author of "), _c('i', [_vm._v("The Missing Husband")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Annie’s mother, Eve, died in childbirth thirty-five years ago. Despite this profound loss, Annie’s made it to adulthood just fine. She enjoys being an estate agent, she loves her partner, Gabe—and now, after two years of trying, she’s finally expecting a baby."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But as her pregnancy progresses, Annie grows anxious about what happened to her mother, wanting to ensure history doesn’t repeat itself. Her quest for more information, though, leads only to frustration. The medical records no longer exist, her mother’s family are estranged, and even her father can’t fill in the blanks."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Then Annie comes across three long-hidden photographs. But these clues to the past raise more questions than answers—and make Annie wonder what’s real and what isn’t . . .")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natasha Boydell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0